export default "__VITE_ASSET__C14ya2TK__"